export function removeAccents(str) {
  const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';

  return str
    .split('')
    .map((letter) => {
      const x = accents.indexOf(letter);
      return x >= 0 ? accentsOut[x] : letter;
    })
    .join('');
}

export function searchLikeRegex(target, query) {
  const newQuery = query.replace(/%/g, '.*');
  const regexp = new RegExp(`^${newQuery}$`);
  return regexp.test(target);
}

export function searchForProduct(_target, _query) {
  const target = removeAccents(_target || '');
  const query = removeAccents(_query || '');

  if (target.indexOf(query) !== -1) {
    return true;
  }

  if (query.indexOf('%') > -1 && searchLikeRegex(target, query)) {
    return true;
  }

  return false;
}
